module.exports = __webpack_public_path__ + "static/media/opakowania_2_B.bf8023f8.png";